import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M9.566 7.39v-.933a3.685 3.685 0 0 1 3.685-3.685h4.875a3.685 3.685 0 0 1 3.684 3.685v11.13a3.685 3.685 0 0 1-3.684 3.685H13.24a3.675 3.675 0 0 1-3.675-3.674v-.944M2.772 12.021h12.041M5.7 9.106l-2.928 2.915L5.7 14.937"
    }, null, -1)
  ]))]))
}
export default { render: render }